<!-- Page banner Area -->
<div class="page-banner bg-1"></div>
<!-- End Page banner Area -->

<div class="section-title">
  <span>Contact Us</span>
  <h2>Get in Touch</h2>
</div>

<!-- Conatct Info -->
<div class="contact-info-contact-us">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="contact-info">
          <i class="bx bxs-phone"></i>
          <h4>Contact Number</h4>

          <p><a>079 48970015/13 /12</a></p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="contact-info">
          <i class="bx bxs-location-plus"></i>
          <h4>Our Location</h4>
          <p>
            201, Abhijeet-I Opp: Kolkata Motors, Mithakhali Six Road,
            Ahmedabad-380009. Gujarat. India.
          </p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
        <div class="contact-info">
          <i class="bx bxs-envelope"></i>
          <h4>Email</h4>
          <p>
            <a href="mailto:info@thevantagetradelink.in"
              >info@thevantagetradelink.in</a
            >
          </p>

          <p>
            <a href="mailto:sales1@thevantagetradelink.in">
              sales1@thevantagetradelink.in</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Conatct Info -->

<!-- Contact Area -->
<div class="contact-form-area">
  <div class="container">
    <div class="section-title">
      <h2>Contact Us Form</h2>
    </div>
    <div class="contact-form">
      <form>
        <div class="row">
          <div class="col-md-6 col-md-6">
            <div class="form-group">
              <input
                type="text"
                name="name"
                class="form-control"
                id="name"
                required
                placeholder="Your name"
                #name
              />
            </div>
          </div>

          <div class="col-md-6 col-md-6">
            <div class="form-group">
              <input
                type="email"
                name="email"
                class="form-control"
                id="email"
                required
                placeholder="Your email address"
                #email
              />
            </div>
          </div>

          <div class="col-md-6 col-md-6">
            <div class="form-group">
              <input
                type="text"
                name="msg_subject"
                id="msg_subject"
                class="form-control"
                required
                placeholder="Your Subject"
                #msg_subject
              />
            </div>
          </div>

          <div class="col-md-6 col-md-6">
            <div class="form-group">
              <input
                type="text"
                name="phone_number"
                class="form-control"
                id="phone_number"
                placeholder="Your phone number"
                #phone_number
              />
            </div>
          </div>

          <div class="col-lg-12 col-md-12">
            <div class="form-group">
              <textarea
                name="message"
                id="message"
                class="form-control"
                cols="30"
                rows="6"
                required
                placeholder="Write your message..."
                #message
              ></textarea>
            </div>
          </div>

          <div class="col-lg-12 col-md-12 text-center">
            <ng-container *ngIf="loading; else submitButton">
              <button type="button" class="btn default-btn-one">
                <mat-spinner [diameter]="24" class="spinner"></mat-spinner>
              </button>
            </ng-container>
            <ng-template #submitButton>
              <button
                type="submit"
                (click)="
                  onSubmit(
                    name,
                    email,
                    msg_subject,
                    phone_number,
                    message,
                    $event
                  )
                "
                class="default-btn-one"
              >
                Send Message
              </button>
            </ng-template>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Contact Area -->
